

























































































































import Card from '@/components/Card.vue'
import ActionButton from '@/components/ActionButton.vue'
import Table from '@/components/Table.vue'
import { TableHeader } from '@/utils/interfaces'
import { Transaction } from '@/utils/interfaces/topup.interface'
import { formatDate } from '@/utils/functions'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { getUsersPayment, updateUsersPayment } from '@/api/Agency/agency.api'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import {
  UserPaymentItem,
  UserPaymentStatus,
} from '@/api/Agency/agency.interface'
import PaymentListFilter from '@/components/Agency/PaymentList/PaymentListFilter.vue'
import ChipStatus from '@/components/ChipStatus.vue'
import Dialog from '@/components/Dialog.vue'
import { mapState } from 'vuex'
import PaymentAssignDialog from '@/components/Agency/PaymentList/PaymentAssignDialog.vue'
import { DeliveryCurrenciesEnum } from '~/utils/interfaces/remittance.interface'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default tableHandler<Transaction>().extend({
  components: {
    appActionButton: ActionButton,
    appConfirmationDialog: ConfirmDialog,
    appPaymentListFilter: PaymentListFilter,
    appChipStatus: ChipStatus,
    appDialog: Dialog,
    appPaymentAssignDialog: PaymentAssignDialog,
    FlatCard,
    FlatTable,
  },
  data: function() {
    return {
      headers: [
        {
          text: this.$t('amount'),
          value: 'amount',
        },
        {
          text: this.$t('sender'),
          value: 'sender',
        },
        {
          text: this.$t('date'),
          value: 'created_at',
        },
        {
          text: this.$t('status'),
          value: 'status',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader[],
      getter: getUsersPayment,
      loading: false,
      loadingItem: null as null | UserPaymentItem,
      confirmDialog: false,
      action: 'CONFIRMED' as UserPaymentStatus,
      details: '',
      detailsDialog: false,
      description: '',
      pendingAssign: null as null | UserPaymentItem,
      assignDialog: true,
      currencies: Object.values(DeliveryCurrenciesEnum),
      remittance_currency: null as null | DeliveryCurrenciesEnum,
      convert_to_balance: false,
      convert_to_credit: false,
    }
  },
  computed: {
    ...mapState(['profile']),
    computedHeaders(): TableHeader[] {
      if (['ADMIN', 'ACCOUNTANT'].includes(this.profile.role)) {
        return [
          {
            text: this.$t('agent'),
            value: 'agent_name',
          },
          ...this.headers,
        ]
      }
      return this.headers
    },
  },
  methods: {
    formatDate(date: string) {
      return formatDate(date)
    },
    changeStatus(item: UserPaymentItem, value: UserPaymentStatus) {
      this.action = value
      this.loadingItem = item
      this.confirmDialog = true
    },
    async onDone(payload: boolean) {
      if (payload && this.loadingItem) {
        this.loading = true
        try {
          await updateUsersPayment(
            this.loadingItem.uuid,
            this.action,
            this.description,
            this.convert_to_credit,
            this.convert_to_balance,
            this.remittance_currency,
          )
          this.loadingItem.status = this.action
        } finally {
          this.loading = false
        }
      }
      this.description = ''
      this.convert_to_balance = false
      this.remittance_currency = null
      this.loadingItem = null
    },
  },
})
